import { useState, useEffect } from 'react';

/**
 * 현재 다크모드 여부만 반환하는 경량 훅
 * html 태그의 class="dark" 변화를 MutationObserver로 감지 → 즉시 반응
 */
export function useIsDark() {
  const [isDark, setIsDark] = useState(
    () => document.documentElement.classList.contains('dark')
  );
  useEffect(() => {
    const obs = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains('dark'));
    });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => obs.disconnect();
  }, []);
  return isDark;
}

/**
 * 다크모드 토글 훅
 * - localStorage에 'pine-theme' 키로 저장
 * - html 태그에 class="dark" 추가/제거
 */
export function useDarkMode() {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('pine-theme');
    if (saved) return saved === 'dark';
    // 시스템 설정 따르기
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('pine-theme', isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggle = () => setIsDark((v) => !v);

  return { isDark, toggle };
}
